import { DateRangePickerValue } from '@mantine/dates';
import dayjs from 'dayjs';

export function validateSelectedRange(
  selectedDateRange: DateRangePickerValue,
  prevDateRange: DateRangePickerValue
) {
  if (selectedDateRange.some((date) => date === null)) {
    return false;
  }

  const currentStart = dayjs(selectedDateRange[0]);
  const prevStart = dayjs(prevDateRange[0]);
  const startDiff = currentStart.diff(prevStart);

  const currentEnd = dayjs(selectedDateRange[1]);
  const prevEnd = dayjs(prevDateRange[1]);
  const endDiff = currentEnd.diff(prevEnd);

  if (startDiff === 0 && endDiff === 0) {
    return false;
  }

  if (currentStart >= currentEnd) {
    return false;
  }

  return true;
}

export function createDefaultRange(): DateRangePickerValue {
  const today = dayjs();
  const todaysDate = today.toDate();
  const sevenDaysAgo = today.subtract(7, 'days').toDate();

  return [sevenDaysAgo, todaysDate];
}
